<template>
  <v-tooltip top :nudge-bottom="3" :content-class="contentClasses">
    <template #activator="{ on, attrs }">
      <slot
        name="activator"
        :attrs="attrs"
        :on="{
          mouseenter: (e) => onTooltip(e, on.mouseenter),
          mouseleave: (e) => onTooltip(e, on.mouseleave),
          focus: (e) => onTooltip(e, on.focus),
          blur: (e) => onTooltip(e, on.blur),
          keydown: (e) => onTooltip(e, on.keydown),
        }"
      >
      </slot>
    </template>
    <slot></slot>
  </v-tooltip>
</template>

<script>
export default {
  name: 'CustomTooltip',
  props: {
    classes: {
      type: String,
      default: '',
    },
  },
  computed: {
    contentClasses() {
      return 'customTooltip ' + this.classes;
    },
  },
  methods: {
    onTooltip(e, fn) {
      if (e.target.offsetWidth < e.target.scrollWidth) {
        fn(e);
      }
    },
  },
};
</script>

<style lang="scss">
.customTooltip {
  &.v-tooltip__content {
    width: 183px;
    height: 54px;
    padding: 7px 6px 2px;
    border-radius: 6px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
    opacity: 0;
    background-color: #4b4b4b;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    &:after,
    &:before {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(33, 33, 33, 0);
      border-top-color: #4b4b4b;
      border-width: 5px;
      margin-left: -5px;
    }
    &:before {
      border-color: rgba(33, 33, 33, 0);
      border-top-color: #4b4b4b;
      border-width: 6px;
      margin-left: -6px;
    }
    &.menuable__content__active {
      opacity: 1 !important;
    }
  }
  &.fixed-content {
    word-break: break-word;
    max-width: 350px;
    height: auto !important;
    width: auto !important;
    padding-bottom: 5px !important;
  }
  &.min-width-content {
    min-width: min-content;
  }
}
</style>
